// extracted by mini-css-extract-plugin
export default {"mainContentWrapper":"styles_mainContentWrapper__7ISIl","cardWrapperStyles":"styles_cardWrapperStyles__vW9EF"};